export default "__VITE_ASSET__b38421da__"